<p>
    <span class="header">{{header}}:&nbsp;</span>
    <ng-content></ng-content>
</p>